import { useEffect, useState } from "react";
import { Z_APPS_TOP_URL } from "../../../../../common/consts";
import { sFetchJson } from "../../../../../common/util/sFetchJson";
import { VocabGenreId, vocab, vocabGenre } from "../../../../../types/vocab";
import { ATargetBlank } from "../../../Link/ATargetBlank";
import { linkShadowStyle } from "../../LinkBlockRender/linkShadowStyle";
import { VList } from "./List";

const initialVocabGenre: vocabGenre = {
    genreId: VocabGenreId(0),
    genreName: "",
    order: 0,
    youtube: "",
    youtubeSpecial: "",
    released: true,
    fallingAnimation: "",
    hasAudio: false,
    hasProductAudio: false,
    locked: false,
};
export function VocabList({ genreName }: { genreName: string }) {
    const genreAndVocab = useGenreAndVocab(genreName);

    return (
        <div
            style={{
                marginBottom: 30,
                textAlign: "center",
                textShadow: "initial",
            }}
        >
            <VList
                g={genreAndVocab.vocabGenre}
                vocabList={genreAndVocab.vocabList}
                style={{ marginBottom: 5 }}
            />
            <ATargetBlank
                href={`${Z_APPS_TOP_URL}/vocabulary-list#${encodeURIComponent(
                    genreAndVocab.vocabGenre.genreName
                )}`}
                style={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    ...linkShadowStyle,
                }}
            >
                {"Check all vocab lists >>"}
            </ATargetBlank>
        </div>
    );
}

function useGenreAndVocab(genreName: string) {
    const [genreAndVocab, setGenreAndVocab] = useState<GenreAndVocab>({
        vocabGenre: initialVocabGenre,
        vocabList: [],
    });

    useEffect(() => {
        let unmounted = false;
        if (genreName) {
            const load = async () => {
                const result = await fetchGenreAndVocab(genreName);
                if (!unmounted && result) {
                    setGenreAndVocab(result);
                }
            };
            void load();
        }
        return () => {
            unmounted = true;
        };
    }, [genreName]);

    return genreAndVocab;
}

interface GenreAndVocab {
    vocabGenre: vocabGenre;
    vocabList: vocab[];
}
async function fetchGenreAndVocab(
    genreName: string
): Promise<GenreAndVocab | null> {
    try {
        return sFetchJson(`api/VocabQuiz/GetQuizDataWithoutCache/${genreName}`);
    } catch (ex) {
        return null;
    }
}
